import { render, staticRenderFns } from "./procedure_authorizations.vue?vue&type=template&id=6c2fc3cc&"
import script from "./procedure_authorizations.vue?vue&type=script&lang=js&"
export * from "./procedure_authorizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports